@if ({ isDarkTheme: (isDarkTheme$ | async) ?? false }; as state) {
  <div class="header-container" [class.theme-dark]="state.isDarkTheme">
    <a routerLink="" class="logo">
      <app-menu-logo [isDarkTheme]="state.isDarkTheme"></app-menu-logo>
    </a>
    <div class="header-content">
      <app-practice-location-header class="practice-location"></app-practice-location-header>
    </div>
    <div class="header-account-dropdown">
      <app-account-dropdown class="dropdown"></app-account-dropdown>
    </div>
  </div>
}
